import {Component, OnInit} from '@angular/core';
import {language} from '../../../language/vn';

@Component({
  templateUrl: './error.component.html'

})
export class ErrorPermissionComponent implements OnInit {
  public language = language;
  ngOnInit(): void {

  }
}
